import { render, staticRenderFns } from "./LayoutSlot.vue?vue&type=template&id=428d7f72&"
var script = {}
import style0 from "./LayoutSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports